(() => {
  const MARKER="SIP_PUBLIC_ROLE_SAFE_HOME_V8";
  const ROOM_PERMS=new Set([
    "room.list","room.add","room.view","room.booking.view",
    "room.booking_list","booking.view","booking.list"
  ]);

  function json(v){
    if(typeof v!=="string"||!v.trim()) return null;
    try{return JSON.parse(v)}catch{return null}
  }

  function jwt(token){
    if(typeof token!=="string"||token.split(".").length!==3) return null;
    try{
      const raw=token.split(".")[1].replace(/-/g,"+").replace(/_/g,"/");
      const p=raw+"=".repeat((4-raw.length%4)%4);
      return JSON.parse(decodeURIComponent(atob(p).split("").map(c=>"%"+("00"+c.charCodeAt(0).toString(16)).slice(-2)).join("")));
    }catch{return null}
  }

  function perms(v){
    if(Array.isArray(v)) return v.map(x=>String(x||"").trim()).filter(Boolean);
    if(typeof v==="string"){
      const p=json(v);
      if(Array.isArray(p)) return perms(p);
      return v.split(/[,\s]+/).map(x=>x.trim()).filter(Boolean);
    }
    return [];
  }

  function collect(obj,out,depth=0){
    if(!obj||typeof obj!=="object"||depth>4) return;

    for(const k of ["role","user_role","userRole"]){
      if(obj[k]!=null) out.roles.push(String(obj[k]).toLowerCase());
    }

    for(const k of ["permissions","permission","perms","user_permissions","userPermissions"]){
      out.permissions.push(...perms(obj[k]));
    }

    for(const k of ["token","accessToken","access_token","jwt"]){
      const d=jwt(obj[k]);
      if(d) collect(d,out,depth+1);
    }

    for(const k of ["user","loginData","login_data","auth","profile"]){
      if(obj[k]&&typeof obj[k]==="object") collect(obj[k],out,depth+1);
    }
  }

  function auth(){
    const out={roles:[],permissions:[]};

    for(const storage of [window.localStorage,window.sessionStorage]){
      if(!storage) continue;
      for(let i=0;i<storage.length;i++){
        const value=storage.getItem(storage.key(i));
        const p=json(value);
        if(p) collect(p,out);
        const d=jwt(value);
        if(d) collect(d,out);
      }
    }

    out.roles=[...new Set(out.roles.map(x=>String(x).trim().toLowerCase()).filter(Boolean))];
    out.permissions=[...new Set(out.permissions.map(x=>String(x).trim()).filter(Boolean))];
    return out;
  }

  function allowed(){
    const a=auth();
    if(a.roles.some(x=>["admin","administrator","superadmin","super_admin"].includes(x))) return true;
    return a.permissions.some(p=>ROOM_PERMS.has(p)||p.startsWith("room."));
  }

  function home(){
    const p=(String(window.location.pathname||"/").replace(/\/+$/,"")||"/");
    return p==="/"||p==="/home";
  }

  function bookingUrl(input){
    let value="";
    try{value=input instanceof Request?input.url:String(input||"")}catch{value=String(input||"")}
    try{
      const u=new URL(value,window.location.origin);
      return u.origin===window.location.origin && /^\/api\/booking(?:\/|$)/.test(u.pathname);
    }catch{
      return /\/api\/booking(?:\/|\?|$)/.test(value);
    }
  }

  function mock(input){
    return home()&&!allowed()&&bookingUrl(input);
  }

  if(typeof window.fetch==="function"){
    const nativeFetch=window.fetch.bind(window);
    window.fetch=function(input,init){
      if(mock(input)){
        console.log(`[${MARKER}] Home /api/booking blocked for role`);
        return Promise.resolve(new Response("[]",{status:200,headers:{"Content-Type":"application/json"}}));
      }
      return nativeFetch(input,init);
    };
  }

  if(window.XMLHttpRequest){
    const nativeOpen=XMLHttpRequest.prototype.open;
    const nativeSend=XMLHttpRequest.prototype.send;
    const nativeHeader=XMLHttpRequest.prototype.setRequestHeader;

    XMLHttpRequest.prototype.open=function(method,url,...rest){
      this.__sipV8Mock=mock(url);
      if(this.__sipV8Mock) return;
      return nativeOpen.call(this,method,url,...rest);
    };

    XMLHttpRequest.prototype.setRequestHeader=function(name,value){
      if(this.__sipV8Mock) return;
      return nativeHeader.call(this,name,value);
    };

    XMLHttpRequest.prototype.send=function(body){
      if(!this.__sipV8Mock) return nativeSend.call(this,body);

      const xhr=this;
      console.log(`[${MARKER}] Home XHR /api/booking blocked for role`);

      setTimeout(()=>{
        const vals={
          readyState:4,status:200,statusText:"OK",
          responseURL:window.location.origin+"/api/booking",
          response:xhr.responseType==="json"?[]:"[]"
        };
        if(xhr.responseType!=="json") vals.responseText="[]";

        for(const [k,v] of Object.entries(vals)){
          try{Object.defineProperty(xhr,k,{configurable:true,value:v})}catch{}
        }

        try{
          xhr.getResponseHeader=n=>String(n||"").toLowerCase()==="content-type"?"application/json":null;
          xhr.getAllResponseHeaders=()=>"content-type: application/json\r\n";
        }catch{}

        for(const type of ["readystatechange","load","loadend"]){
          try{xhr.dispatchEvent(new Event(type))}catch{}
        }
      },0);
    };
  }

  const NOTE_ID="sip-home-room-note-v8";

  function applyUi(){
    if(!home()||allowed()){
      const old=document.getElementById(NOTE_ID);
      if(old) old.remove();
      return;
    }

    const title=[...document.querySelectorAll("h1,h2,h3,h4,h5,div,span")]
      .find(el=>String(el.textContent||"").replace(/\s+/g," ").trim().toLowerCase()==="jadwal booking ruangan");

    if(!title) return;

    let box=title.closest("section,.card,.content,.dashboard-content,.main-content")||title.parentElement;
    if(!box||box===document.body||box.dataset.sipV8RoomHidden==="1") return;

    box.dataset.sipV8RoomHidden="1";

    for(const child of [...box.children]){
      child.dataset.sipV8Display=child.style.display||"";
      child.style.display="none";
    }

    const note=document.createElement("div");
    note.id=NOTE_ID;
    note.style.cssText="margin:24px;padding:20px 22px;background:#fff;border:1px solid #e5e7eb;border-radius:12px;font-family:inherit";
    note.innerHTML=
      '<div style="font-weight:700;font-size:18px;margin-bottom:6px">Home</div>'+
      '<div style="font-size:14px;color:#4b5563">Menu dan data yang tampil mengikuti akses yang dipilih admin.</div>';

    box.appendChild(note);
    console.log(`[${MARKER}] booking calendar hidden`);
  }

  let queued=false;
  function queue(){
    if(queued) return;
    queued=true;
    setTimeout(()=>{queued=false;applyUi()},80);
  }

  new MutationObserver(queue).observe(document.documentElement,{childList:true,subtree:true});
  window.addEventListener("popstate",queue);
  [100,400,1000,2000].forEach(ms=>setTimeout(queue,ms));

  console.log(`[${MARKER}] installed`);
})();
